import { render, staticRenderFns } from "./ProjectTypeEdit.vue?vue&type=template&id=71a414ba&scoped=true&"
import script from "./ProjectTypeEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectTypeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a414ba",
  null
  
)

export default component.exports